import { useState } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import { ReactComponent as ArrowRightIcon} from '../assets/svg/keyboardArrowRightIcon.svg'
import visibilityIcon from '../assets/svg/visibilityIcon.svg'
import OAuth from "../components/OAuth";

function SignIn() {

  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email:'',
    password:''
  });
  const {email, password} = formData
  const navigate = useNavigate()

  const onChange = (e)=>{
    setFormData(prevState=>({
      ...prevState,
      [e.target.id]: e.target.value
    }))
  }

  const onSubmit = async (e)=>{
    e.preventDefault()
    try {
      const auth = getAuth();
      const userCredentials = await signInWithEmailAndPassword(
        auth,
        email,
        password
      )

      if (userCredentials.user) {
        navigate("/");
      }
    } catch (error) {
      toast.error("Invalid User Credentias");
    }

  }

  return (
    <>
      <div className="pageContainer">
        <header>
          <p className="pageHeader">Welcome Back!</p>
        </header>
        <main>
          <form onSubmit={onSubmit}>
            <input
              type="email"
              className="emailInput"
              placeholder="Email"
              id="email"
              value={email}
              onChange={onChange}
            />
            <div className="passwordInputDiv">
              <input
                type={showPassword ? "text" : "password"}
                className="passwordInput"
                placeholder="Password"
                onChange={onChange}
                id="password"
              />
              <img
                src={visibilityIcon}
                alt="Show Password"
                className="showPassword"
                onClick={() => setShowPassword((prev) => !prev)}
              />
            </div>
            <Link to="/forgot-password" className="forgotPasswordLink">
              Forgot Passowrd
            </Link>

            <div className="signInBar">
              <p className="signInText">
                <button className="signInButton">
                  <ArrowRightIcon fill="#fff" width="34px" height="34px" />
                </button>
              </p>
            </div>
          </form>

          <OAuth />
          <Link to="/sign-up" className="registerLink">
            Sign Up instead
          </Link>
        </main>
      </div>
    </>
  );
}

export default SignIn;
